import { defineMessages } from 'react-intl';

export const profileMessages = defineMessages({
    'profile.title': {
        id: 'profile.title',
        defaultMessage: 'Profile',
        description: 'Title for the profile Page.',
    },
    'profile.edit': {
        id: 'profile.edit',
        defaultMessage: 'Edit',
        description: 'Button to edit the profile.',
    },
    'profile.email_label': {
        id: 'profile.email_label',
        defaultMessage: 'Email Support',
        description: 'Button to email support.',
    },
    'profile.signin_description': {
        id: 'profile.signin_description',
        defaultMessage: 'You are signed in using your:',
        description: 'Explanation of how the user is signed in.',
    },
    'profile.login_description': {
        id: 'profile.login_description',
        defaultMessage: 'You are logged in using your:',
        description: 'Explanation of how the user is logged in.',
    },
    'profile.theme.label': {
        id: 'profile.theme.label',
        defaultMessage: 'Select a theme',
        description: 'Button to select a theme.',
    },
    'profile.theme.unset': {
        id: 'profile.theme.unset',
        defaultMessage: 'Use browser setting (default)',
        description: 'Button to remove the theme.',
    },
    'profile.theme.dark': {
        id: 'profile.theme.dark',
        defaultMessage: 'Use Dark Theme',
        description: 'Button to use the dark theme.',
    },
    'profile.theme.light': {
        id: 'profile.theme.light',
        defaultMessage: 'Use Light Theme',
        description: 'Button to use the light theme.',
    },
    'profile.most_recent': {
        id: 'profile.most_recent',
        defaultMessage: 'Most Recent',
        description: 'Header for the most recent content section',
    },
    'profile.history': {
        id: 'profile.history',
        defaultMessage: 'History',
        description: 'Header for the history section',
    },
    'profile.sponsor_detail': {
        id: 'profile.sponsor_detail',
        defaultMessage: 'Sponsor Detail',
        description: 'Section title for the sponsor',
    },
    'profile.sponsor_label': {
        id: 'profile.sponsor_label',
        defaultMessage: 'Your Calm Health Sponsor',
        description: "Label for the sponsor of a user's subscription",
    },
    'profile.sponsor_logo_alt': {
        id: 'profile.sponsor_logo_alt',
        defaultMessage: 'Offered through {partnerName}',
        description:
            "Accessible name for a sponsor/partner's welcome logo image, always built client-side from partnerDisplayName instead of trusting the backend-configured welcomeLogo/welcomeSquareLogo altText field, which is sometimes insufficiently descriptive (e.g. 'Offered through Calm Demo' where 'Calm Demo' is the actual sponsor name in that environment)",
    },
    'profile.sponsor.heading': {
        id: 'profile.sponsor.heading',
        defaultMessage: 'Calm Health is provided to you by {sponsor}',
        description: "Describing the sponsor of a user's subscription",
    },
    'profile.sponsor.dependent.heading': {
        id: 'profile.sponsor.dependent.heading',
        defaultMessage: 'Access to Calm Health is invite only.',
        description: 'Heading for dependent user',
    },
    'profile.sponsor.subheading': {
        id: 'profile.sponsor.subheading',
        defaultMessage:
            'Access to Calm Health can be sponsored by employers, healthcare providers, or health insurance organizations.',
        description: 'Explanation of what a sponsor is sponsor',
    },
    'profile.sponsor.invited_by_label': {
        id: 'profile.sponsor.invited_by_label',
        defaultMessage: 'Invited by:',
        description: 'Label for the name of who invited the user',
    },
    'profile.sponsor.access_code_label': {
        id: 'profile.sponsor.access_code_label',
        defaultMessage: 'Sponsorship Access Code:',
        description: 'Label for the sponsor access code',
    },
    'profile.sponsor.group_label': {
        id: 'profile.sponsor.group_label',
        defaultMessage: 'Sponsor Group:',
        description: 'Label for the sponsor group',
    },
    'profile.sponsor.eligibility_support': {
        id: 'profile.sponsor.eligibility_support',
        defaultMessage: 'Eligibility Support',
        description: 'Heading for the eligibility support section',
    },
    'profile.sponsor.expires_label': {
        id: 'profile.sponsor.expires_label',
        defaultMessage: 'Sponsorship Ends:',
        description: 'Label for the sponsorship expiration date',
    },
    'profile.sponsor.update_sponsor_heading': {
        id: 'profile.sponsor.update_sponsor_heading',
        defaultMessage: 'Have a different access code?',
        description: 'Button to update the sponsor',
    },
    'profile.sponsor.update_sponsor_text': {
        id: 'profile.sponsor.update_sponsor_text',
        defaultMessage:
            'Update your Calm Health sponsorship here with your new access code or use the information provided in the invitation you received by email.',
        description: 'Explanation of updating the sponsor',
    },
    'profile.sponsor.update_sponsor_cta': {
        id: 'profile.sponsor.update_sponsor_cta',
        defaultMessage: 'Update Sponsor',
        description: 'Button to update the sponsor',
    },
    'profile.settings.heading': {
        id: 'profile.settings.heading',
        defaultMessage: 'Settings',
        description: 'Header for the settings section',
    },
    'profile.health_summary_section_title': {
        id: 'profile.health_summary_section_title',
        defaultMessage: 'Health Summary',
        description: 'Title of the health summary section',
    },
    'profile.health_summary_section_subtitle.initial_load': {
        id: 'profile.health_summary_section_subtitle.initial_load',
        defaultMessage: 'Retrieving your Health Summary document...',
        description: 'Text to display when the health summary is loading',
    },
    'profile.health_summary_section_subtitle.not_generated': {
        id: 'profile.health_summary_section_subtitle.not_generated',
        defaultMessage:
            'Click the button below to generate your Health Summary document.',
        description: 'Button to generate the health summary',
    },
    'profile.health_summary_section_subtitle.available': {
        id: 'profile.health_summary_section_subtitle.available',
        defaultMessage:
            'Your Health Summary is available to download. Update your document if there has been recent activity in the app you would like to include.',
        description: 'Text to display when the health summary is available',
    },
    'profile.health_summary_section_subtitle.international': {
        id: 'profile.health_summary_section_subtitle.international',
        defaultMessage:
            "You will no longer be able to access the content you've been using in Calm Health. But, you can download your data and associated records",
        description: 'Text to display when the health summary is available',
    },
    'profile.health_summary_generating': {
        id: 'profile.health_summary_generating',
        defaultMessage: 'Generating your Health Summary',
        description: 'Text to display while the health summary is generating',
    },
    'profile.health_summary_generate': {
        id: 'profile.health_summary_generate',
        defaultMessage: 'Generate Health Summary',
        description: 'Button to generate the health summary',
    },
    'profile.health_summary_update': {
        id: 'profile.health_summary_update',
        defaultMessage: 'Update Health Summary',
        description: 'Button to update the health summary',
    },
    'profile.health_summary_generation_error': {
        id: 'profile.health_summary_generation_error',
        defaultMessage: 'We could not generate at this time. Please try again.',
        description:
            'Error message when the health summary cannot be generated',
    },
    'profile.health_summary_retry': {
        id: 'profile.health_summary_retry',
        defaultMessage: 'Retry',
        description: 'Button to retry generating the health summary',
    },
    'profile.health_summary_document_name': {
        id: 'profile.health_summary_document_name',
        defaultMessage: 'Health Summary',
        description: 'Title of the health summary document',
    },
    'profile.download_health_summary': {
        id: 'profile.download_health_summary',
        defaultMessage: 'Download Health Summary',
        description: 'Button to download the health summary',
    },
    'profile.download_health_summary_pdf': {
        id: 'profile.download_health_summary_pdf',
        defaultMessage: 'Download Health Summary PDF',
        description:
            'Accessible name for the health summary download link/button, including the file format',
    },
    'profile.health_summary_loading_dialog': {
        id: 'profile.health_summary_loading_dialog',
        defaultMessage: 'Health Summary Loading Dialog',
        description: 'Loading dialog for the health summary',
    },
    'profile.health_summary_loading_dialog_title': {
        id: 'profile.health_summary_loading_dialog_title',
        defaultMessage: 'Your Health Summary is being generated.',
        description:
            'Text to display while the health summary is being generated',
    },
    'profile.health_summary_loading_dialog_subtitle': {
        id: 'profile.health_summary_loading_dialog_subtitle',
        defaultMessage:
            'The most recently generated health summary document will always be available from your profile page.',
        description: 'Explanation of whete the health summary can be found',
    },
    'profile.health_summary_not_created': {
        id: 'profile.health_summary_not_created',
        defaultMessage: 'Health summary not created',
        description: 'Text to display when the health summary is not created',
    },
    'profile.manage_calm_account': {
        id: 'profile.manage_calm_account',
        defaultMessage: 'Manage Calm Account',
        description: 'Button to manage the Calm account',
    },
    'profile.phone_label': {
        id: 'profile.phone_label',
        defaultMessage: 'Call Support',
        description: 'Button to call support',
    },
    'profile.phone_subtitle': {
        id: 'profile.phone_subtitle',
        defaultMessage: 'Call {name} with any eligibility questions',
        description: 'Explanation of what to call support for',
    },
    'profile.security_valued_title': {
        id: 'profile.security_valued_title',
        defaultMessage: 'We take your account security seriously.',
        description: 'Title for the section explaining account security',
    },
    'profile.security_valued_subtitle': {
        id: 'profile.security_valued_subtitle',
        defaultMessage:
            'Before you manage your account, you will need to verify your identity. This will help keep your personal information secure.',
        description:
            'Explanation of why the user needs to verify their identity',
    },
    'profile.screening.title': {
        id: 'profile.screening.title',
        defaultMessage: 'Tell us more about you',
        description: 'Title for the mental health screening',
    },
    'profile.screening.subtitle': {
        id: 'profile.screening.subtitle',
        defaultMessage:
            'Your plan will update dynamically as you tell us more information. Try changing your goals, updating your issues or conditions, or taking the mental health screening.',
        description:
            'Explanation of how the mental health screening improves the plan',
    },
    'profile.screening.results.title': {
        id: 'profile.screening.results.title',
        defaultMessage: 'Mental Health Screening',
        description: 'Title for the mental health screening results',
    },
    'profile.screening.results_disclaimer_1': {
        id: 'profile.screening.results_disclaimer_1',
        defaultMessage:
            'These results are not intended to diagnose any mental health conditions.*',
        description: 'Disclaimer for the mental health screening results',
    },
    'profile.screening.results_disclaimer_2': {
        id: 'profile.screening.results_disclaimer_2',
        defaultMessage:
            '*These results, and the use of Calm Health, are not intended to diagnose or treat depression, anxiety, or any other mental or physical health condition. These results, and the use of Calm Health, are not a substitute for care by a physician or other health care provider. Any questions that you may have regarding these results or the diagnosis, care, or treatment of a health condition should be directed to your physician or health care provider. Calm Health is a mental wellness product.',
        description: 'Disclaimer for the mental health screening results',
    },
    'profile.screening.update': {
        id: 'profile.screening.update',
        defaultMessage: 'Update Screening',
        description: 'Button to take the mental health screening',
    },
    'profile.logout_dialog.cancel': {
        id: 'profile.logout_dialog.cancel',
        defaultMessage: 'Cancel',
        description: 'Button to close the logout dialog without logging out',
    },
    'profile.logout_dialog.confirm': {
        id: 'profile.logout_dialog.confirm',
        defaultMessage: 'Log out',
        description: 'Button to log out',
    },
    'profile.logout_dialog.confirmText': {
        id: 'profile.logout_dialog.confirmText',
        defaultMessage: 'Are you sure you want to log out?',
        description: 'Confirmation text for logging out',
    },
    'profile.logout_dialog.title': {
        id: 'profile.logout_dialog.title',
        defaultMessage: 'Log out',
        description: 'Title for the logout dialog',
    },
    'profile.delete_account.deleting_account': {
        id: 'profile.delete_account.deleting_account',
        defaultMessage: 'Deleting your Account',
        description: 'Title for the delete account section',
    },
    'profile.delete_account.confirm_title': {
        id: 'profile.delete_account.confirm_title',
        defaultMessage: 'Are you sure you want to delete your account?',
        description: 'Confirmation text for deleting the account',
    },
    'profile.delete_account.confirm_subtitle': {
        id: 'profile.delete_account.confirm_subtitle',
        defaultMessage:
            'Deleting your account is irreversible and means you will no longer be able to access your Calm Health data and associated records. Please download your Health Summary data first.',
        description: 'Explanation of what deleting the account means',
    },
    'profile.delete_account.confirm_subtitle_with_invites': {
        id: 'profile.delete_account.confirm_subtitle_with_invites',
        defaultMessage:
            'Deleting your account is irreversible and means you will no longer be able to access your Calm Health data and associated records. Please download your Health Summary data first. {br} Note: Invited friends & family members will also lose access to Calm Health.',
        description:
            'Explanation of what deleting the account means with a note about your invitees',
    },
    'profile.delete_account.confirm_disclaimer': {
        id: 'profile.delete_account.confirm_disclaimer',
        defaultMessage:
            'Please note that this request does not affect the data in your Calm Account. If you wish to delete your Calm Account, use <link1>these instructions</link1>.',
        description: 'Disclaimer for deleting the account',
    },
    'profile.delete_account.confirm_success_title': {
        id: 'profile.delete_account.confirm_success_title',
        defaultMessage: 'Your Calm Health account has been deleted',
        description: 'Confirmaion that the account has been deleted',
    },
    'profile.delete_account.dsr_request_received_title': {
        id: 'profile.delete_account.dsr_request_received_title',
        defaultMessage:
            "We've received your request and are working on it. You'll receive an email when it's complete.",
        description:
            'Confirmation shown when an account deletion request is submitted via DataGrail (not yet completed)',
    },
    'profile.delete_account.confirm_success_subtitle': {
        id: 'profile.delete_account.confirm_success_subtitle',
        defaultMessage: 'We are sorry to see you go.',
        description: 'Text to display after the account has been deleted',
    },
    'profile.delete_account.confirm_success_disclaimer': {
        id: 'profile.delete_account.confirm_success_disclaimer',
        defaultMessage:
            'Please note that we retain some personal information as permitted by applicable law or contract for record keeping or legal compliance purposes. For example, Calm may retain records related to your request, information required to be retained under HIPAA, and information maintained in an unstructured environment. See Calm Health’s <link1>Privacy Policy</link1> to learn more.',
        description:
            'Disclaimer about the data that is retained, shown after the account has been deleted',
    },
    'profile.delete_account.confirm_success_disclaimer2': {
        id: 'profile.delete_account.confirm_success_disclaimer2',
        defaultMessage:
            'Additionally, the data in your Calm Account has not been deleted. If you wish to delete your Calm Account, use <link1>these instructions.</link1>',
        description:
            "Explanation that the data in the user's Calm Account has not been deleted",
    },
    'profile.delete_account.error_title': {
        id: 'profile.delete_account.error_title',
        defaultMessage: 'Something went wrong.',
        description:
            'Title for the error message when the account cannot be deleted',
    },
    'profile.delete_account.error_body': {
        id: 'profile.delete_account.error_body',
        defaultMessage: 'We could not delete your account. Please try again.',
        description: 'Explanation that the account could not be deleted',
    },
    'profile.delete_account.error_confirm': {
        id: 'profile.delete_account.error_confirm',
        defaultMessage: 'Ok',
        description:
            'Confirmation button for the error message when the account cannot be deleted',
    },
    'profile.delete_account.logout_cancel': {
        id: 'profile.delete_account.logout_cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for the logout dialog',
    },
    'profile.delete_account.logout_confirm': {
        id: 'profile.delete_account.logout_confirm',
        defaultMessage: 'Ok',
        description: 'Confirmation button for the logout dialog',
    },
    'profile.about_you.title': {
        id: 'profile.about_you.title',
        defaultMessage: 'About You',
        description: 'Title for the about you section',
    },
    'profile.about_you.update': {
        id: 'profile.about_you.update',
        defaultMessage: 'Update',
        description: 'Button to update the about you section',
    },
    'profile.about_you.conditions': {
        id: 'profile.about_you.conditions',
        defaultMessage: 'Your Conditions',
        description: 'Header for the conditions section',
    },
    'profile.about_you.conditions_cta': {
        id: 'profile.about_you.conditions_cta',
        defaultMessage: 'Add your mental and physical health conditions',
        description: 'Prompt for the user to add their conditions',
    },
    'profile.about_you.dobAndGender': {
        id: 'profile.about_you.dobAndGender',
        defaultMessage: 'Your Date of Birth and Gender',
        description: 'Header for the date of birth and gender section',
    },
    'profile.about_you.dobAndGender_lower_case': {
        id: 'profile.about_you.dobAndGender_lower_case',
        defaultMessage: 'Your date of birth and gender',
        description: 'Header for the date of birth and gender dialog',
    },
    'profile.about_you.goals': {
        id: 'profile.about_you.goals',
        defaultMessage: 'Your Goals',
        description: 'Header for the goals section',
    },
    'profile.about_you.goals_cta': {
        id: 'profile.about_you.goals_cta',
        defaultMessage: "Let's identify your goals",
        description: 'Prompt for the user to add their goals',
    },
    'profile.about_you.dob_and_gender_cta': {
        id: 'profile.about_you.age_cta',
        defaultMessage: 'Add your date of birth and gender',
        description:
            'Prompt for the user to add their date of birth and gender',
    },
    'profile.about_you.dob_and_gender_dialog_title': {
        id: 'profile.about_you.dob_and_gender_dialog_title',
        defaultMessage: 'Add/Edit',
        description:
            'Dialog title for adding/editing the date of birth and gender',
    },
    'profile.about_you.gender_cta': {
        id: 'profile.about_you.gender_cta',
        defaultMessage: 'Add Gender',
        description: 'Prompt for the user to add their gender info',
    },
    'profile.about_you.profile_updated': {
        id: 'profile.about_you.profile_updated',
        defaultMessage: 'Profile Updated',
        description: 'Confirmation that the profile has been updated',
    },
    'profile.about_you.topics': {
        id: 'profile.about_you.topics',
        defaultMessage: 'Your Topics',
        description: 'Header for the topics section',
    },
    'profile.about_you.topics_cta': {
        id: 'profile.about_you.topics_cta',
        defaultMessage: 'What topics are you interested in?',
        description: 'Prompt for the user to add their topics',
    },
    'profile.friends_and_family.title': {
        id: 'profile.friends_and_family.title',
        defaultMessage: 'Manage Friends and Family',
        description: 'Title for the friends and family pod',
    },
    'profile.friends_and_family.subtitle': {
        id: 'profile.friends_and_family.subtitle',
        defaultMessage: 'Invite up to 5 People',
        description: 'Subtitle for the friends and family pod',
    },
});

export default profileMessages;
